import Router from 'vue-router'
import { getAuthState } from './index'
const subPage = {
  template: '<router-view></router-view>'
}

export default class extends Router {
  constructor (arg) {
    super(arg)
    this.map({
      '/login': {
        component: require('./components/pages/Login.vue'),
        noauth: true
        // noloading: true
      },
      '/': {
        name: 'index',
        component: require('./components/pages/Index.vue')
      },
      '/smart-controller': {
        name: 'smart-controller',
        component: subPage,
        subRoutes: {
          '/production': {
            component: require('./components/pages/Production.vue')
          },
          '/history': {
            component: require('./components/pages/History.vue')
          },
          '/firmware': {
            component: require('./components/pages/FwChangeLog.vue')
          },
          '/production-activity': {
            component: require('./components/pages/Activity.vue')
          }
        }
      }
    })
    this.beforeEach(({ to, next, abort }) => {
      if (to.path === '/') {
        this.replace('/smart-controller/production')
      }
      if (to.matched === null) {
        console.log('state is null')
        abort()
        this.replace('/')
      } else if (to.noauth) {
        getAuthState().then(state => {
          console.log('to.noauth', state)
          if (state) this.replace('/')
          else next()
        })
      } else {
        getAuthState().then(state => {
          if (state) {
            return next()
          }
          abort()
          this.replace('/login')
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Router.js